
<div class="card card-report">
  <div class="card-header">
    <h5 class="title">Worker Competency and Training Report</h5>
  </div>

  <div class="card-body card-report__overflow">
    <div class="row">
      <div class="col-md-12">
        <p>Report showing workers with their competency and induction/training expiry dates</p>
      </div>
    </div>
  </div>

  <div class="card-report__actions">
    <button type="button" [disabled]="!siteOwnerId" (click)="generateReport()" class="btn btn-success btn-round">
      <strong>Generate Report</strong>
    </button>
  </div>
  
</div>
